/**
 * Global Toastify System — auto-bundled via main.js
 * Icons are injected by toastify.jinja into window.__toastifyIcons at render time.
 */

function getToastIcon(type) {
    const icons = window.__toastifyIcons || {};
    return icons[type] || "";
}

function getToastifyPosition(position) {
    const positions = {
        "top-left":      { gravity: "top",    position: "left",   offset: { x: "1rem", y: "1rem" } },
        "top-center":    { gravity: "top",    position: "center", offset: { x: 0,       y: "1rem" } },
        "top-right":     { gravity: "top",    position: "right",  offset: { x: "1rem", y: "1rem" } },
        "center-left":   { gravity: "top",    position: "left",   offset: { x: "1rem", y: "50vh" } },
        "center":        { gravity: "top",    position: "center", offset: { x: 0,       y: "50vh" } },
        "center-right":  { gravity: "top",    position: "right",  offset: { x: "1rem", y: "50vh" } },
        "bottom-left":   { gravity: "bottom", position: "left",   offset: { x: "1rem", y: "1rem" } },
        "bottom-center": { gravity: "bottom", position: "center", offset: { x: 0,       y: "1rem" } },
        "bottom-right":  { gravity: "bottom", position: "right",  offset: { x: "1rem", y: "1rem" } },
    };
    return positions[position] || positions["top-right"];
}

window.toast = function (message, options = {}) {
    if (typeof Toastify === "undefined") {
        console.warn("Toastify library not loaded — toast suppressed:", message);
        return;
    }

    const description = options.description || "";
    let type = (options.type || "default").toLowerCase();
    const position = options.position || "top-right";
    const duration = options.duration || 4000;
    const html = options.html || "";

    if (type === "sucess") type = "success";

    const positionConfig = getToastifyPosition(position);
    let toastContent;

    if (html) {
        toastContent = html;
    } else {
        const icon = getToastIcon(type);
        toastContent = `
            <div class="toastify-content-wrapper">
                ${icon ? `<span class="toast-icon">${icon}</span>` : ""}
                <div class="toast-content">
                    <div class="toast-message">${message}</div>
                    ${description ? `<div class="toast-description">${description}</div>` : ""}
                </div>
            </div>
        `;
    }

    Toastify({
        text: toastContent,
        duration,
        close: true,
        gravity: positionConfig.gravity,
        position: positionConfig.position,
        stopOnFocus: true,
        escapeMarkup: false,
        className: `toast-${type}`,
        offset: positionConfig.offset,
        onClick: function () {},
    }).showToast();
};

if (!window.toastifyInitialized) {
    window.toastifyInitialized = true;

    const recentToasts = new Map();
    const DEDUP_WINDOW = 1000;

    function isDuplicateToast(message, type) {
        const key = `${message}-${type}`;
        const now = Date.now();
        if (recentToasts.has(key)) {
            if (now - recentToasts.get(key) < DEDUP_WINDOW) return true;
        }
        recentToasts.set(key, now);
        for (const [k, timestamp] of recentToasts.entries()) {
            if (now - timestamp > DEDUP_WINDOW) recentToasts.delete(k);
        }
        return false;
    }

    function initToastListeners() {
        if (window.toastifyListenersRegistered) return;
        window.toastifyListenersRegistered = true;

        document.body.addEventListener("htmx:afterRequest", function (event) {
            if (event.detail.elt && event.detail.elt.hasAttribute("data-no-toast")) return;
            if (event.detail.successful) {
                try {
                    const response = JSON.parse(event.detail.xhr?.responseText);
                    if (response && (response.message || response.title || response.description)) {
                        document.body.dispatchEvent(new CustomEvent("showToast", {
                            detail: response,
                            bubbles: true,
                        }));
                    }
                } catch (e) { /* ignore non-JSON */ }
            }
        });

        document.body.addEventListener("showToast", function (event) {
            let toastData = event.detail;
            if (
                !toastData ||
                (typeof toastData === "object" && toastData.nodeType) ||
                Array.isArray(toastData) ||
                (typeof toastData === "object" && !toastData.message && !toastData.title && !toastData.description)
            ) return;

            if (typeof toastData === "string") {
                try { toastData = JSON.parse(toastData); }
                catch (e) { toastData = { message: toastData }; }
            }

            if (toastData && toastData.showToast) toastData = toastData.showToast;

            if (!toastData || typeof toastData !== "object" ||
                (!toastData.message && !toastData.title && !toastData.description)) return;

            let type = (toastData.type || "default").toLowerCase().trim();
            if (type === "sucess") type = "success";
            if (type === "danger") type = "error";

            let message, description;
            if (toastData.message)          { message = toastData.message;     description = toastData.description || ""; }
            else if (toastData.title)       { message = toastData.title;       description = toastData.description || ""; }
            else if (toastData.description) { message = toastData.description; description = ""; }
            else                            { message = "Notification";         description = ""; }

            const position = toastData.position || "top-right";
            const duration = toastData.duration || 4000;

            if (isDuplicateToast(message, type)) return;

            window.toast(message, { type, description, position, duration });
        });
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", initToastListeners);
    } else {
        initToastListeners();
    }
}
